module.exports = __webpack_public_path__ + "media/images/icons/favicon-5f196ce6a3391d72471bfd3811b79a49.png";